import { faqData } from '@/mocks/homeData';

export default function SectionFAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            常见问答
          </h2>
          <p className="text-foreground-500 text-sm mt-2">关于91免费在线视频的常见问题解答</p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqData.map((faq) => (
            <div key={faq.id} className="bg-background-50 rounded-xl p-5 md:p-6">
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-600 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}